export class UndisturbedTemperature {
  public constructor(init?: Partial<UndisturbedTemperature>) {
    Object.assign(this, init);
  }

  constantGradient: {
    surfaceAmbientTemperature: number;
    mudlineTemperature: number;
    temperatureGradient: number;
  }
  customPoints: CustomPoint[];
  isConstantGradient: boolean;
  temperatureAtTd?: number;
}

export class CustomPoint {
  public constructor(init?: Partial<CustomPoint>) {
    Object.assign(this, init);
  }

  public trueVerticalDepth: number;
  public temperature: number;
}

export class UndisturbedTemperaturePlot {
  public constructor(init?: Partial<UndisturbedTemperaturePlot>) {
    Object.assign(this, init);
  }

  public type: string;
  public x: number[];
  public y: number[];
}

export class UdtPlotUi {
  public constructor(init?: Partial<UdtPlotUi>) {
    this.plotFormationTops = init && init.plotFormationTops || false;
  }
  plotFormationTops: boolean;
}

/**
 * NEW VIEWMODEL INTERFACES FOR V2 COMPONENT
 * These support the modernized constant-gradient component
 */

/**
 * Validation rules provided by backend
 * All constraints are optional - can have just min, just max, or both
 */
export interface ValidationRules {
  min?: number;
  max?: number;
  required?: boolean;
}

/**
 * Context for constant gradient calculations
 * Provides the straight line parameters for temperature interpolation
 */
export interface ConstantGradientCalcContext {
  topTvd: number;           // Top true vertical depth (0 for land, mudline for offshore)
  totalDepthTvd: number;    // Total depth true vertical depth
  topTemperature: number;   // Temperature at top (surface for land, mudline for offshore)
  gradientDenominator: number
}

/**
 * View model for constant gradient section
 * Backend provides data, validation, and calculation context as a cohesive unit
 */
export interface ConstantGradientViewModel {
  data: {
    surfaceAmbientTemperature: number;
    mudlineTemperature?: number;  // Optional - backend determines existence based on well type
    temperatureGradient: number;
    temperatureAtTd: number;
  };
  validation: {
    surfaceAmbientTemperature: ValidationRules;
    mudlineTemperature?: ValidationRules;  // Optional - only exists if mudlineTemperature exists
    temperatureGradient: ValidationRules;
    temperatureAtTd: ValidationRules;
  };
  calcContext: ConstantGradientCalcContext;
}

/**
 * View model for custom UDT section
 * Backend provides data and validation rules for custom temperature points
 */
export interface CustomUdtViewModel {
  data: {
    customPoints: CustomPoint[];
  };
  validation: {
    trueVerticalDepth: ValidationRules;  // Validation for depth values
    temperature: ValidationRules;        // Validation for temperature values
  };
}

/**
 * Full UDT view model (for V2 component)
 * Service provides complete data + metadata for UI rendering
 * Units come from UnitService, not from backend
 */
export interface UdtViewModel {
  isConstantGradient: boolean; // Which mode is active: true = gradient, false = custom
  totalDepthTvd: number;
  totalDepthMd: number;
  drillFloorElevation: number;
  mudlineDepth?: number;       // Optional - only for offshore wells
  constantGradient: ConstantGradientViewModel;
  custom: CustomUdtViewModel;  // Backend uses 'custom' not 'customUdt'
}
